const getSafeAmount = amount => {
	const parsedAmount = Number(amount);
	return Number.isFinite(parsedAmount) && parsedAmount > 0 ? parsedAmount : 0;
};

// safely adds a new item to the same row, with defaults
export const normalizeRepeatedItems = (items = [], amount, createDefaultItem = () => ({})) => {
	const safeAmount = getSafeAmount(amount);

	return Array.from({ length: safeAmount }, (_, index) => ({
		...createDefaultItem(index),
		...(items[index] || {}),
	}));
};

// safely updates one row at a time, with the requested patch applied immutably
export const updateRepeatedItem = (items = [], index, patch, createDefaultItem = () => ({})) => {
	const minimumLength = Math.max(items.length, index + 1);
	const nextItems = normalizeRepeatedItems(items, minimumLength, createDefaultItem);
	const currentItem = nextItems[index];
	const itemPatch = typeof patch === 'function' ? patch(currentItem) : patch;

	nextItems[index] = {
		...currentItem,
		...itemPatch,
	};

	return nextItems;
};
